import * as React from "react";
import { useRef, useEffect } from "react";
import Avatar from "./Avatar.jsx";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useDispatch, useSelector } from "react-redux";
import {
  userLogoutAction,
  userProfileAction,
} from "../redux/actions/userAction";
import SideBar from "./SideBar";
const pages = ["Home", "Log In"];

const Navbar = () => {
  const headerRef = useRef(null);

  useEffect(() => {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const headerElement = headerRef.current;
      if (!headerElement) {
        return;
      } else if (currentScrollPos === 0) {
        headerElement.style.transform = "translateY(0)";
        headerElement.style.backgroundColor = "transparent";
      } else if (prevScrollPos < currentScrollPos) {
        headerElement.style.transform = "translateY(0)";
        headerElement.style.backgroundColor = " #6f42c1";
      } else {
        headerElement.style.transform = "translateY(-200px)";
      }
      prevScrollPos = currentScrollPos;
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  //show / hide button
  const { userInfo } = useSelector((state) => state.signIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // log out user
  const logOutUser = () => {
    dispatch(userLogoutAction(navigate));
  };

  React.useEffect(() => {
    dispatch(userProfileAction());
  });

  return (
    <>
      <SideBar />
      <header
        className="site-navbar p-3   "
        style={{ transition: "0.5s" }}
        ref={headerRef}
      >
        <div className="container-fluid">
          <div className="row align-items-center NavContain">
            <div className=" col-6 LogoDiv">
              <Link
                to
                style={{
                  textDecoration: "none",
                  color: "white",
                  fontFamily: "cursive",
                }}
              >
                Jobify
              </Link>
            </div>
            <nav className="mx-auto site-navigation">
              <ul
                className="site-menu js-clone-nav d-none d-xl-block ml-0 pl-0"
                style={{ fontFamily: "cursive" }}
              >
                <li>
                  <Link to="/" className="nav-link active">
                    Home
                  </Link>
                </li>
                <li>
                  <a
                    href="#jobs"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    {" "}
                    Jobs
                  </a>
                </li>
                {userInfo?.user?.type === "user" && (
                  <li>
                    <Link to="/appliedJobs" className="active">
                      applied Jobs
                    </Link>
                  </li>
                )}
                {userInfo?.user.type === "businessman" ? (
                  <li>
                    <Link to="/company/appliedUsers" className="active">
                      My Company
                    </Link>
                  </li>
                ) : (
                  <></>
                )}

                <li>
                  <Link
                    style={{ textDecoration: "none" }}
                    to="/contact"
                    className="active"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </nav>
            {userInfo ? (
              <>
                <div
                  className={`right-cta-menu text-right d-flex align-items-end justify-content-end  ${userInfo.user.type === "businessman" ? "col-3" : "col-2"
                    }`}
                >
                  <div
                    className="CreateJobDiv"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Avatar
                      userId={userInfo.user._id}
                      userType={userInfo.user.type}
                      username={userInfo.user.username}
                      profile={userInfo.user.profilePic.url}
                      logout={logOutUser}
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="right-cta-menu text-right d-flex align-items-center col-6">
                <div className="ml-auto">
                  <div className="Navbuttons">
                    <button >
                      <Link
                        to="/login"
                        
                        style={{
                          textDecoration: "none",
                          color: "white",
                        }}
                      >
                        Login
                        <span></span>
                      </Link>
                    </button>
                    <Link
                      to='/register'
                      style={{
                        textDecoration: "none",
                        color: "white",
                      }}>
                      <button
                        
                        type="button"
                        style={{
                         
                          color: "white",
                        }}
                      >
                        Register
                        <span></span>
                      </button>
                    </Link>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <Link className="dropdown-item" to={`/register`}>
                        As user
                      </Link>
                      <Link className="dropdown-item" to="/registerAsBusiness">
                        As Company Owner
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};
export default Navbar;
